export const GREENHOUSE_API_BASE_URL = "https://boards-api.greenhouse.io";

export interface IDepartment {
  name: string;
  jobs: IJob[];
  title: string;
  childDepartments: Array<IDepartment>;
  parentDepartment?: string;
}

export interface IJob {
  metadata: { name?: string };
  title: string;
  type: string;
  location: { name: string };
  absolute_url: string;
}
